module.exports = __webpack_public_path__ + "img/lianxi.8ebc3b0f.png";